// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t-orm-page{padding:25px 20px;height:100%}.t-orm-page.mobile{padding-top:15px;margin-bottom:55px}@media(min-width:600px){.t-orm-page{padding:25px}}.t-orm-page__payment-reminder{font-family:mariupol-regular,sans-serif;font-size:.69rem;color:#ff002b;border:2px solid #ff002b;border-radius:10px;font-weight:700;padding:5px;width:100%;display:inline}.t-orm-page__title{font-size:1.25rem;font-weight:500}@media(min-width:960px){.t-orm-page__title{font-size:1.75rem}}", ""]);
// Exports
module.exports = exports;
